import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import { galleryImages } from '../data/hotelData';
import './GalleryPage.css';

const categories = ['all', 'exterior', 'rooms', 'pool', 'dining', 'spa'];

export default function GalleryPage() {
  const [filter, setFilter] = useState('all');
  const [lightbox, setLightbox] = useState(null);

  const filtered = filter === 'all' ? galleryImages : galleryImages.filter(i => i.category === filter);

  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <span className="section-badge">Visual Tour</span>
          <h1>Our Gallery</h1>
          <p>Explore Grand Luxe through our lens</p>
        </div>
      </div>

      <section className="section gallery-page">
        <div className="container">
          <div className="gallery-filter-bar">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-btn ${filter === cat ? 'active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat === 'all' ? 'All' : cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>

          <motion.div className="gallery-page-grid" layout>
            {filtered.map((img, i) => (
              <motion.div
                key={img.id}
                className="gallery-page-item"
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
                onClick={() => setLightbox(img)}
              >
                <img src={img.src} alt={img.title} loading="lazy" />
                <div className="gallery-page-overlay">
                  <span>{img.title}</span>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            className="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
          >
            <motion.div
              className="lightbox-content"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={e => e.stopPropagation()}
            >
              <button className="lightbox-close" onClick={() => setLightbox(null)}><FaTimes /></button>
              <img src={lightbox.src} alt={lightbox.title} />
              <p className="lightbox-caption">{lightbox.title}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </main>
  );
}
